import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';
import api from '../services/api';

export const ROUTE_CAPABILITIES = {
  '/patients': ['clinical.view'], '/pricing': ['finance.profitability.view'],
  '/inventory': ['inventory.view'], '/inventory/audit': ['inventory.audit'],
  '/reports': ['finance.view'], '/monthly-reports': ['finance.view'],
  '/consultant-ledger': ['finance.view'], '/lab-consultant-ledger': ['finance.view'],
  '/clinic-workflow': ['admin.profile.manage'], '/follow-ups': ['appointment.schedule'],
  '/prescriptions/new': ['clinical.view', 'clinical.prescription.open'],
  '/invoices/new': ['billing.invoice.create'], '/emi-reminders': ['billing.emi.manage'],
};

export function canAccessRoute(pathname, capabilities) {
  if (!Array.isArray(capabilities)) return false;
  const route = Object.keys(ROUTE_CAPABILITIES).sort((a, b) => b.length - a.length)
    .find((path) => pathname === path || pathname.startsWith(path + '/'));
  return !route || ROUTE_CAPABILITIES[route].every((capability) => capabilities.includes(capability));
}

export default function ProtectedRoute() {
  const { token, user, setUser } = useAuthStore();
  const { pathname } = useLocation();
  const [verifiedToken, setVerifiedToken] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!token) return undefined;
    let active = true;
    setError(false);
    api.get('/auth/me').then(({ data }) => {
      if (active) { setUser(data.user); setVerifiedToken(token); }
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [token, setUser]);
  if (!token) return <Navigate to="/login" replace />;
  if (error) return <div role="alert" className="p-6">Unable to verify access. Please reload and try again.</div>;
  if (verifiedToken !== token) return <div role="status" className="p-6">Loading your workspace...</div>;
  if (!canAccessRoute(pathname, user?.capabilities)) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
